import { Paper, Typography, styled, css, Button } from '@mui/material';
import { theme } from 'assets/themes/zizzi';
import Points from 'components/Points';

const typographyStyles = css`
  font-size: 20px;

  ${theme.breakpoints.up('md')} {
    font-size: 24px;
  }
`;

export const StyledPaper = styled(Paper)`
  align-items: center;
  border-radius: ${theme.radius?.sm};
  display: flex;
  justify-content: space-between;
  margin: auto;
  padding: 0.5rem 1rem;
`;

export const StyledText = styled(Typography)`
  ${typographyStyles};
  font-weight: bold;
  line-height: 1.1;
  margin-right: 0.3rem;
`;

export const StyledPoints = styled(Points)`
  .MuiTypography-subtitle1 {
    ${typographyStyles};
  }
`;

export const StyledButton = styled(Button)`
  padding: 0;
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
